import zaludGeneralQuestions, {
  ZaludGeneralQuestionFieldAnswers
} from './general/questions';
import zaludNoseSinusesQuestions, {
  ZaludNoseSinusesQuestionFieldAnswers
} from './noseSinuses/questions';
import zaludThroatPainQuestions, {
  ZaludThroatPainQuestionFieldAnswers
} from './throatPain/questions';
import zaludColdFluQuestions, {
  ZaludColdFluQuestionFieldAnswers
} from './coldFlu/questions';
import zaludPinkEyeQuestions, {
  ZaludPinkEyeQuestionFieldAnswers
} from './pinkEye/questions';
import zaludEarInfectionQuestions, {
  ZaludEarInfectionQuestionFieldAnswers
} from './earInfection/questions';
import zaludSTIQuestions, {
  ZaludSTIQuestionFieldAnswers
} from './STI Intake/questions';
import zaludUtiTreatmentQuestions, {
  ZaludUtiTreatmentQuestionFieldAnswers
} from './utiTreatment/questions';
import zaludYeastInfectionQuestions, {
  ZaludYeastInfectionQuestionFieldAnswers
} from './yeastInfection/questions';

const ZaludQuestions = [
  ...zaludGeneralQuestions,
  ...zaludNoseSinusesQuestions,
  ...zaludThroatPainQuestions,
  ...zaludColdFluQuestions,
  ...zaludPinkEyeQuestions,
  ...zaludEarInfectionQuestions,
  ...zaludSTIQuestions,
  ...zaludUtiTreatmentQuestions,
  ...zaludYeastInfectionQuestions
];
export default ZaludQuestions;

export type ZaludQuestionFieldAnswers = ZaludGeneralQuestionFieldAnswers &
  ZaludNoseSinusesQuestionFieldAnswers &
  ZaludThroatPainQuestionFieldAnswers &
  ZaludColdFluQuestionFieldAnswers &
  ZaludPinkEyeQuestionFieldAnswers &
  ZaludEarInfectionQuestionFieldAnswers &
  ZaludSTIQuestionFieldAnswers &
  ZaludUtiTreatmentQuestionFieldAnswers &
  ZaludYeastInfectionQuestionFieldAnswers;
